import React from 'react';
import PropTypes from 'prop-types';
import icon from '../images/common/alert.svg';

const style = {
  main: {
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: '#2F3243',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    zIndex: 999,
  },
  iconWrapper: {
    width: 100,
    height: 100,
    background: '#fff',
    borderRadius: 50,
    margin: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 50,
    height: 50,
    background: '#fff',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toTop: {
    width: 200,
    height: 50,
    textDecoration: 'none',
    cursor: 'pointer',
    border: '1px solid #fff',
    borderRadius: 5,
    padding: 5,
    margin: 10,
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#FF4242',
  },
};

const ScreenLock = ({ msgs }) => (
  <div style={style.main}>
    <div style={style.info}>
      {msgs.map((msg, i) => (
        <div key={`msg${i + 1}`}>{msg}</div>
      ))}
      <div style={style.iconWrapper}>
        <img style={style.icon} src={icon} alt="screenLock" />
      </div>
    </div>
  </div>
);

ScreenLock.propTypes = {
  msgs: PropTypes.array.isRequired,
};

export default ScreenLock;
